import Vue from 'vue';
import Vuex from 'vuex';
import Api from "@/store/Api";

Vue.use(Vuex);

const BOTTLE_ACTIONS = [
	'/bottles/at_customer.json',
	'/bottles/back_in_storage.json',
	'/bottles/entered_storage.json',
	'/bottles/from_customer.json',
	'/bottles/left_storage.json',
	'/bottles/to_customer.json',
	'/bottles/waiting_for_pickup.json',
];

export default new Vuex.Store({
	state: {
		UILock: false,			//true while fetch is pending
		authToken: null,		//JSON webtoken
		authTokenData: null,
		
		apiBaseUrl: process.env.VUE_APP_API_BASE_URL,
		
		requestQueue: [],
		
		//custom states
		userDetails: null,
		
		users: [],
		bottles: [],
		customers: [],
		
		bottleCollection: [],
		selectedCustomerId: null,
		
		selectedDueDate: null,
		selectedBottleType: null,
		bottleTypes: [
			'2kg',
			'6kg',
			'10kg kurz',
			'10kg lang',
			'20kg Mischgas',
			'Stickstoff 3.5',
			'Stickstoff 5.0'
		],
	},
	getters: {
		getAuthHeader: (state) => {
			return {
				'X-Authorization': 'Bearer ' + state.authToken
			}
		},
		getLatestActionId: (state) => (serial) => {
			let bottle = state.Api.Bottles.all.find(bottle => bottle.serial === serial);
			
			if (bottle && Array.isArray(bottle.bottle_actions)) {
				let latestAction = bottle.bottle_actions[0];
				if (latestAction) {
					return latestAction.id
				}
			}
		},
		getSelectedCustomer: (state) => state.customers.find(el => el.id === state.selectedCustomerId)
	},
	mutations: {
		setUILock: (state, UILock) => state.UILock = UILock,
		
		// Auth
		// setAuthToken: (state, authToken) => {
		// 	state.authToken = authToken;
		// 	window.localStorage.setItem(process.env.VUE_APP_AUTH_TOKEN_STORAGE_KEY, authToken)
		// },
		// setAuthTokenData: (state, data) => {
		// 	state.authTokenData = data;
		// },
		// clearAuthToken: (state) => {
		// 	state.authToken = null;
		// 	state.authTokenData = null;
		// 	window.localStorage.removeItem(process.env.VUE_APP_AUTH_TOKEN_STORAGE_KEY)
		// },
		
		// Queue
		// setQueue: (state, queue) => state.requestQueue = queue,
		// pushQueue: (state, item) => {
		// 	if (item.signal) {
		// 		item.signal = null
		// 	}
		// 	state.requestQueue.push(item);
		// 	window.localStorage.setItem('requestQueue', JSON.stringify(state.requestQueue))
		// },
		// popQueue: (state) => {
		// 	state.requestQueue.shift();
		// 	window.localStorage.setItem('requestQueue', JSON.stringify(state.requestQueue))
		// },
		// addParentIdToQueuedItems: (state, {serial, parentId}) => {
		// 	for (let i = 0; i < state.requestQueue.length; i++) {
		// 		if (state.requestQueue[i].serial === serial) {
		// 			state.requestQueue[i].parentId = parentId;
		// 			break;
		// 		}
		// 	}
		// },
		
		// Users
		// setUserDetails: (state, details) => {
		// 	state.userDetails = details
		// },
		// setUsers: (state, users) => {
		// 	state.users = users
		// },
		// updateUser: (state, user) => {
		// 	let idx = state.users.findIndex(el => el.id === user.id);
		// 	Object.assign(state.users[idx], user);
		// },
		
		// Bottles
		// setBottles: (state, bottles) => {
		// 	state.bottles = bottles
		// },
		// updateBottle: (state, bottle) => {
		// 	let idx = state.bottles.findIndex(el => el.id === bottle.id);
		// 	Object.assign(state.bottles[idx], bottle);
		// },
		//
		// Customers
		// setCustomers: (state, customers) => {
		// 	state.customers = customers
		// },
		// updateCustomer: (state, customer) => {
		// 	let idx = state.customers.findIndex(el => el.id === customer.id);
		// 	Object.assign(state.customers[idx], customer);
		// },
		//
		// addActionsToBottles: (state, actions = []) => {
		// 	actions.forEach(action => {
		// 		let bottle_idx = state.bottles.findIndex(el => el.id === action.bottle_id);
		// 		if (bottle_idx && Array.isArray(state.bottles[bottle_idx].bottle_actions)) {
		// 			state.bottles[bottle_idx].bottle_actions.unshift(action)
		// 		} else {
		// 			console.log('addActionsToBottles => can\'t find bottle')
		// 		}
		// 	})
		//
		// },
		
		// App State
		setBottleCollection: (state, collection = []) => {
			if (Array.isArray(collection)) {
				state.bottleCollection = collection
			}
		},
		setSelectedCustomerId: (state, id) => state.selectedCustomerId = id,
		setSelectedDueDate: (state, date) => state.selectedDueDate = date,
		setSelectedBottleType: (state, type) => state.selectedBottleType = type,
	},
	// actions: {
	// 	// users
	// 	login: ({dispatch}, {username, password}) => {
	// 		let headers = {
	// 			'Content-Type': 'application/json',
	// 		};
	//
	// 		return dispatch('apiRequest', {
	// 			actionPath: '/users/login.json',
	// 			method: 'POST',
	// 			headers: headers,
	// 			data: {
	// 				username: username,
	// 				password: password,
	// 			},
	// 			UILock: true
	// 		})
	// 	},
	// 	logout: ({dispatch, getters, rootGetters}) => {
	// 		let headers = {
	// 			'Content-Type': 'application/json',
	// 		};
	// 		Object.assign(headers, rootGetters["Api/getAuthHeader"]);
	//
	// 		return dispatch('apiRequest', {
	// 			actionPath: '/users/logout.json',
	// 			method: 'POST',
	// 			headers: headers
	// 		})
	// 	},
	//
	// 	fetchUserDetails: ({dispatch, getters, commit, rootGetters}, {user_id = "self"} = {}) => {
	// 		let headers = {
	// 			'Content-Type': 'application/json',
	// 		};
	// 		Object.assign(headers, rootGetters["Api/getAuthHeader"]);
	//
	// 		return dispatch('apiRequest', {
	// 			actionPath: '/users/get/' + user_id + '.json',
	// 			method: 'GET',
	// 			headers: headers,
	// 		}).then(result => {
	// 			commit('setUserDetails', result);
	// 			return Promise.resolve(result);
	// 		})
	// 	},
	// 	refreshUsers: ({dispatch, getters, commit, rootGetters}) => {
	// 		let headers = {
	// 			'Content-Type': 'application/json',
	// 		};
	// 		Object.assign(headers, rootGetters["Api/getAuthHeader"]);
	//
	// 		return dispatch('apiRequest', {
	// 			actionPath: '/users/all.json',
	// 			method: 'GET',
	// 			headers: headers,
	// 		}).then(result => commit('setUsers', result))
	// 	},
	// 	addUser: ({dispatch, getters, commit, rootGetters}, {id, username, role, active, password}) => {
	// 		let headers = {
	// 			'Content-Type': 'application/json',
	// 		};
	// 		Object.assign(headers, rootGetters["Api/getAuthHeader"]);
	//
	// 		return dispatch('apiRequest', {
	// 			actionPath: '/users/add.json',
	// 			method: 'PUT',
	// 			headers: headers,
	// 			data: {
	// 				username: username,
	// 				role: role,
	// 				active: active,
	// 				password: password
	// 			}
	// 		})
	// 	},
	// 	modifyUserDetails: ({dispatch, getters, commit, rootGetters}, {id, username, role, active, password}) => {
	// 		let headers = {
	// 			'Content-Type': 'application/json',
	// 		};
	// 		Object.assign(headers, rootGetters["Api/getAuthHeader"]);
	//
	// 		return dispatch('apiRequest', {
	// 			actionPath: '/users/modify/' + id + '.json',
	// 			method: 'PATCH',
	// 			headers: headers,
	// 			data: {
	// 				username: username,
	// 				role: role,
	// 				active: active,
	// 				password: password
	// 			}
	// 		}).then(result => commit('updateUser', result))
	// 	},
	//
	// 	// bottles
	// 	refreshBottles: ({dispatch, getters, commit, rootGetters}) => {
	// 		let headers = {
	// 			// 'Content-Type': 'application/json',
	// 		};
	// 		Object.assign(headers, rootGetters["Api/getAuthHeader"]);
	//
	// 		return dispatch('apiRequest', {
	// 			actionPath: '/bottles/all.json',
	// 			method: 'GET',
	// 			headers: headers
	// 		}).then(result => commit('setBottles', result))
	// 	},
	// 	fetchBottleDetails: ({dispatch, getters, rootGetters}, {bottle_id}) => {
	// 		let headers = {
	// 			'Content-Type': 'application/json',
	// 		};
	// 		Object.assign(headers, rootGetters["Api/getAuthHeader"]);
	//
	// 		return dispatch('apiRequest', {
	// 			actionPath: '/bottles/get/' + bottle_id + '.json',
	// 			method: 'GET',
	// 			headers: headers,
	// 		})
	// 	},
	// 	modifyBottleDetails: ({dispatch, getters, commit, rootGetters}, {id, due, type}) => {
	// 		let headers = {
	// 			'Content-Type': 'application/json',
	// 		};
	// 		Object.assign(headers, rootGetters["Api/getAuthHeader"]);
	//
	// 		return dispatch('apiRequest', {
	// 			actionPath: '/bottles/modify/' + id + '.json',
	// 			method: 'PATCH',
	// 			headers: headers,
	// 			data: {
	// 				due: due,
	// 				type: type
	// 			}
	// 		}).then(result => commit('updateBottle', result))
	// 	},
	//
	// 	addBottlesToInventory: ({state, dispatch, getters, rootGetters}, {activeBottles}) => {
	// 		let bottles = activeBottles.map(bottle_id => {
	// 			return {
	// 				"serial": bottle_id,
	// 				"due": state.selectedDueDate + "T00:00:00",
	// 				"type": state.selectedBottleType,
	// 				"parent_id": getters.getLatestActionId(bottle_id)
	// 			}
	// 		});
	//
	// 		let headers = {
	// 			'Content-Type': 'application/json',
	// 		};
	// 		Object.assign(headers, rootGetters["Api/getAuthHeader"]);
	//
	// 		return dispatch('queuedApiRequest', {
	// 			actionPath: '/bottles/entered_storage.json',
	// 			method: 'POST',
	// 			headers: headers,
	// 			data: {
	// 				bottles: bottles
	// 			}
	// 		})
	//
	// 	},
	// 	addBottlesToInventoryAdmin: ({state, dispatch, getters, rootGetters}, bottles) => {
	// 		bottles = bottles.map(bottle => {
	// 			return {
	// 				...bottle,
	// 				"parent_id": getters.getLatestActionId(bottle.serial)
	// 			}
	// 		});
	//
	// 		let headers = {
	// 			'Content-Type': 'application/json',
	// 		};
	// 		Object.assign(headers, rootGetters["Api/getAuthHeader"]);
	//
	// 		return dispatch('queuedApiRequest', {
	// 			actionPath: '/bottles/entered_storage.json',
	// 			method: 'POST',
	// 			headers: headers,
	// 			data: {
	// 				bottles
	// 			}
	// 		})
	//
	// 	},
	// 	moveBottlesAtCustomer: ({dispatch, getters, commit, rootGetters}, {bottles}) => {
	//
	// 		let headers = {
	// 			'Content-Type': 'application/json',
	// 		};
	// 		Object.assign(headers, rootGetters["Api/getAuthHeader"]);
	//
	// 		return dispatch('queuedApiRequest', {
	// 			actionPath: '/bottles/at_customer.json',
	// 			method: 'POST',
	// 			headers: headers,
	// 			data: {
	// 				bottles: bottles
	// 			}
	// 		}).then(result => {
	// 			commit('addActionsToBottles', result);
	// 			return Promise.resolve(result)
	// 		})
	//
	// 	},
	// 	moveBottlesFromCustomer: ({dispatch, getters, commit, rootGetters}, {bottles}) => {
	//
	// 		let headers = {
	// 			'Content-Type': 'application/json',
	// 		};
	// 		Object.assign(headers, rootGetters["Api/getAuthHeader"]);
	//
	// 		return dispatch('queuedApiRequest', {
	// 			actionPath: '/bottles/from_customer.json',
	// 			method: 'POST',
	// 			headers: headers,
	// 			data: {
	// 				bottles: bottles
	// 			}
	// 		}).then(result => {
	// 			if (result) {
	// 				commit('addActionsToBottles', result);
	// 			}
	// 			return Promise.resolve(result);
	// 		})
	//
	// 	},
	// 	moveBottlesBackInStorage: ({dispatch, getters, commit, rootGetters}, {bottles}) => {
	//
	// 		let headers = {
	// 			'Content-Type': 'application/json',
	// 		};
	// 		Object.assign(headers, rootGetters["Api/getAuthHeader"]);
	//
	// 		return dispatch('apiRequest', {
	// 			actionPath: '/bottles/back_in_storage.json',
	// 			method: 'POST',
	// 			headers: headers,
	// 			data: {
	// 				bottles: bottles
	// 			}
	// 		}).then(result => {
	// 			commit('addActionsToBottles', result);
	// 			return Promise.resolve(result)
	// 		})
	//
	// 	},
	// 	bottlesLeftStorage: ({dispatch, getters, commit, rootGetters}, {bottles}) => {
	// 		let headers = {
	// 			'Content-Type': 'application/json',
	// 		};
	// 		Object.assign(headers, rootGetters["Api/getAuthHeader"]);
	//
	// 		return dispatch('apiRequest', {
	// 			actionPath: '/bottles/left_storage.json',
	// 			method: 'POST',
	// 			headers: headers,
	// 			data: {
	// 				bottles: bottles
	// 			}
	// 		}).then(result => {
	// 			commit('addActionsToBottles', result);
	// 			return Promise.resolve(result)
	// 		})
	//
	// 	},
	//
	// 	// customers
	// 	refreshCustomers: ({dispatch, getters, commit, rootGetters}) => {
	// 		let headers = {
	// 			'Content-Type': 'application/json',
	// 		};
	// 		Object.assign(headers, rootGetters["Api/getAuthHeader"]);
	//
	// 		return dispatch('apiRequest', {
	// 			actionPath: '/customers/all.json',
	// 			method: 'GET',
	// 			headers: headers,
	// 		}).then(result => commit('setCustomers', result))
	// 	},
	// 	fetchCustomerDetails: ({dispatch, getters, rootGetters}, {customer_id}) => {
	// 		let headers = {
	// 			'Content-Type': 'application/json',
	// 		};
	// 		Object.assign(headers, rootGetters["Api/getAuthHeader"]);
	//
	// 		return dispatch('apiRequest', {
	// 			actionPath: '/customers/get/' + customer_id + '.json',
	// 			method: 'GET',
	// 			headers: headers,
	// 		})
	// 	},
	// 	addCustomer: ({dispatch, getters, commit, rootGetters}, {
	// 		name,
	// 		address,
	// 		postal,
	// 		city,
	// 		phone,
	// 		fax,
	// 		email,
	// 		customer_number
	// 	}) => {
	// 		let headers = {
	// 			'Content-Type': 'application/json',
	// 		};
	// 		Object.assign(headers, rootGetters["Api/getAuthHeader"]);
	//
	// 		return dispatch('apiRequest', {
	// 			actionPath: '/customers/add.json',
	// 			method: 'PUT',
	// 			headers: headers,
	// 			data: {
	// 				name: name,
	// 				address: address,
	// 				postal: postal,
	// 				city: city,
	// 				phone: phone,
	// 				fax: fax,
	// 				email: email,
	// 				customer_number,
	// 			}
	// 		}).then(result => commit('updateCustomer', result))
	// 	},
	// 	modifyCustomerDetails: ({dispatch, getters, commit, rootGetters}, {
	// 		id,
	// 		address,
	// 		postal,
	// 		city,
	// 		phone,
	// 		email
	// 	}) => {
	// 		let headers = {
	// 			'Content-Type': 'application/json',
	// 		};
	// 		Object.assign(headers, rootGetters["Api/getAuthHeader"]);
	//
	// 		return dispatch('apiRequest', {
	// 			actionPath: '/customers/modify/' + id + '.json',
	// 			method: 'PATCH',
	// 			headers: headers,
	// 			data: {
	// 				address: address,
	// 				postal: postal,
	// 				city: city,
	// 				phone: phone,
	// 				email: email
	// 			}
	// 		}).then(result => commit('updateCustomer', result))
	// 	},
	//
	//
	// 	/**
	// 	 *
	// 	 * @param state
	// 	 * @param commit
	// 	 * @param dispatch
	// 	 * @param actionPath
	// 	 * @param method
	// 	 * @param headers
	// 	 * @param data
	// 	 * @param UILock
	// 	 * @param abortSignal
	// 	 * @returns {Promise<Response>}
	// 	 */
	// 	apiRequest: ({state, commit, dispatch}, {
	// 		actionPath,
	// 		method,
	// 		headers = {},
	// 		data = undefined,
	// 		UILock = false,
	// 		abortSignal = null
	// 	}) => {
	// 		if (UILock) {
	// 			commit('setUILock', true);
	//
	// 		}
	// 		let options = {
	// 			method: method,
	// 			headers: headers,
	// 			credentials: 'include',
	// 			// mode: 'no-cors',
	// 			signal: abortSignal
	// 		};
	//
	// 		if (data) {
	// 			options.body = headers['Content-Type'] === 'application/json' ? JSON.stringify(data) : data
	// 		}
	//
	//
	// 		return fetch(state.apiBaseUrl + actionPath, options)
	// 			.then(response => {
	// 				console.log('API response', response);
	//
	// 				if (UILock) {
	// 					commit('setUILock', false);
	// 				}
	//
	// 				if (response.headers.get('content-type').split(';')[0] === 'application/json') {
	// 					return response.json();
	// 				}
	//
	// 				return response.text();
	// 			})
	// 			.then(async (json) => {
	// 				if (json.status === 'ok') {
	//
	// 					if (json.data && json.data.token) {
	//
	// 						try {
	// 							await dispatch('updateAuthToken', json.data.token)
	// 						} catch (e) {
	// 							json.error = {
	// 								code: 900,
	// 								en: 'received invalid token, ' + e
	// 							}
	//
	// 						}
	//
	// 					}
	//
	// 					console.log('resolve api request with data', json)
	//
	// 					return json.data;
	// 				}
	//
	// 				if (json.status === 'error') {
	// 					throw json.error;
	// 				}
	//
	// 				throw 'unknown json response';
	// 			})
	// 	},
	// 	queuedApiRequest: async ({state, commit, getters, dispatch}, options = null) => {
	//
	// 		if (options) {
	// 			commit('pushQueue', options);
	// 		}
	//
	// 		let result;
	// 		while (state.requestQueue.length !== 0) {
	// 			result = null;
	// 			try {
	// 				let queuedOptions = JSON.parse(JSON.stringify(state.requestQueue[0]));//Object.assign({}, );
	//
	// 				console.log('try queued request with options', queuedOptions);
	//
	// 				if (queuedOptions.headers.Authorization) {
	// 					Object.assign(queuedOptions.headers, getters.getAuthHeader);
	// 				}
	//
	// 				console.log('after merge headers', queuedOptions)
	//
	// 				result = await dispatch('apiRequest', queuedOptions);
	// 				commit('popQueue');
	//
	// 				if (BOTTLE_ACTIONS.indexOf(queuedOptions.actionPath) && result.id) {
	// 					commit('addParentIdToQueuedItems', {
	// 						serial: queuedOptions.serial,
	// 						parentId: result.id
	// 					})
	// 				}
	//
	// 			} catch (error) {
	// 				console.log('catch queue', state.requestQueue[0], error)
	// 				// debugger;
	// 				if (typeof error === "string") {
	// 					// break queue on network errors
	// 					throw 'network error, added to queue'
	// 				} else if (state.requestQueue.length === 0) {
	// 					// throw api errors
	// 					throw error
	// 					// TODO: eventuell hier nicht throw error um queue nicht abzubrechen
	// 				}
	// 			}
	// 			return result;
	// 		}
	//
	// 	},
	// 	updateAuthToken: ({commit}, authToken) => {
	// 		return new Promise((resolve, reject) => {
	// 			if (authToken) {
	// 				let tokenParts = authToken.split('.');
	// 				if (tokenParts.length === 3) {
	// 					// 0 = headers, 1 = payload, 2 = signature
	// 					let tokenPayload = JSON.parse(atob(tokenParts[1]));
	//
	// 					if (tokenPayload.exp * 1000 < Date.now()) {
	// 						return reject('token expired');
	// 					}
	//
	// 					commit('setAuthToken', authToken);
	// 					commit('setAuthTokenData', tokenPayload);
	//
	// 					return resolve(authToken);
	//
	// 				} else {
	// 					return reject('unwell formatted data')
	// 				}
	// 			} else {
	// 				return reject('missing token')
	// 			}
	// 		})
	// 	}
	// },
	modules: {Api}
})
